import "./Channel.scss";

import iso from "iso-3166-1";
import { DateTime } from "luxon";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { fetchChannel } from "../../actions/channel";
import { fetchForecastData, fetchWeatherData } from "../../actions/weather";
import favouritePNG from "../../images/favourite.png";
import { getThisChannel } from "../../selectors/channel";
import { isLoggedIn } from "../../selectors/user";
import ActivationPending from "./ActivationPending";
import Activator from "./Activator";
import ConditionsFundStatus from "./ConditionsFundStatus";
import CurrentStats from "./CurrentStats";
import Forecast from "./Forecast";
import ForecastActivator from "./ForecastActivator";
import ForecastFundStatus from "./ForecastFundStatus";
import StationInfo from "./StationInfo";
import WeatherChart from "./WeatherChart";
import WeatherTable from "./WeatherTable";

class Channel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDatapoint: null,
      activationPending: false,
      period: "day",
      chartMetric: "temperature",
      favourite: false,
      units: localStorage.getItem("units") ?? "metric",
    };

    this.handleChartClick = this.handleChartClick.bind(this);
    this.handlePayment = this.handlePayment.bind(this);
    this.setPeriod = this.setPeriod.bind(this);
    this.setChartMetric = this.setChartMetric.bind(this);
  }

  fetchInitialFavouriteState = async () => {
    const channelId = this.props.match.params.id;

    try {
      const response = await fetch(`/api/users/self/favourites/${channelId}`, {
        credentials: "include",
      });
      this.setState({ favourite: response.status === 200 });
    } catch (error) {
      console.error("Error fetching favourite state:", error);
    }
  };

  toggleFavouriteState = async () => {
    const isFavourite = !this.state.favourite;
    this.setState({ favourite: isFavourite });

    await fetch(`/api/users/self/favourites/${this.props.channel.id}`, {
      credentials: "include",
      method: isFavourite ? "POST" : "DELETE",
    });
  };

  handleChartClick(event) {
    if (event) {
      const datapoint = event.activePayload[0].payload;
      this.setState({ selectedDatapoint: datapoint });
    }
  }

  setPeriod(period) {
    this.setState({ period: period });
    const channelID = this.props.match.params.id;

    if (this.props.weather[channelID][period]) return;
    this.props.fetchWeatherData(channelID, period);
  }

  setChartMetric(metric) {
    this.setState({ chartMetric: metric });
  }

  handlePayment(payment) {
    if (payment.status === "RECEIVED") {
      this.setState({ activationPending: true });
    } else console.log(payment);
  }

  handleSetUnits = (units) => {
    localStorage.setItem("units", units);
    this.setState({ units });
  };

  componentDidMount() {
    console.log(this.state);
    const channelID = this.props.match.params.id;
    this.props.fetchChannel(channelID);
    this.props.fetchForecastData(channelID);
    this.props.fetchWeatherData(channelID, this.state.period);

    this.fetchInitialFavouriteState();
  }

  render() {
    const { activationPending, period, chartMetric, units } = this.state;
    const { loggedIn, channel } = this.props;
    if (!channel) return null;
    const weather = this.props.weather[channel.id] || {};
    // First render nothing will be ready
    // if (!weather) return null;

    const forecastActivated = channel.status && channel.status.forecast;
    const hasBeenActivated = channel.status && channel.status.active;
    const hideForecasts = channel?.source?.type !== "openweathermap";
    const isFunded =
      channel.status &&
      channel.status.active_until &&
      DateTime.fromISO(channel.status.active_until) > DateTime.utc();
    const weatherData = weather[period] || [];
    const metric = units === "metric";

    let { selectedDatapoint } = this.state;
    if (selectedDatapoint === null && weatherData.length > 0) {
      selectedDatapoint = weatherData[weatherData.length - 1];
    }

    const { AUD_BSV } = this.props.settings.stats;

    return (
      <div className="horizontal-center">
        <div>
          <div id="heading">
            {loggedIn && (
              <img
                alt=""
                src={favouritePNG}
                title="Set favourite"
                onClick={this.toggleFavouriteState}
                className={`favourite-icon ${
                  this.state.favourite ? "" : "unfavourite"
                }`}
              />
            )}
            <h1>
              {channel.location.name},{" "}
              {iso.whereAlpha2(channel.location.country).country}
            </h1>
          </div>
          {channel.current &&
            DateTime.utc()
              .diff(DateTime.fromISO(channel.current.datetime))
              .as("hours") < 12 && (
              <div className="info-container">
                <div>
                  <CurrentStats
                    metric={metric}
                    daily={channel.daily}
                    current={channel.current}
                    timezone={channel.location.timezone}
                  />
                </div>
                {channel.source.type === "custom" && (
                  <StationInfo channel={channel} />
                )}
              </div>
            )}
        </div>
        {weatherData.length === 0 && weather.pending && (
          <h2>Loading Weather</h2>
        )}
        {!hasBeenActivated && activationPending && <ActivationPending />}
        {!activationPending && !channel.pending && !hasBeenActivated && (
          <Activator channel={channel} onPayment={this.handlePayment} />
        )}
        {weatherData.length === 0 &&
          !weather.pending &&
          hasBeenActivated &&
          isFunded && (
            <div>
              <h2>Channel Activated</h2>
              <p>Pending initial data feed</p>
            </div>
          )}
        {weatherData.length === 0 &&
          !weather.pending &&
          hasBeenActivated &&
          !isFunded && (
            <div>
              <h2>Channel Funds Depleted</h2>
              <p>Top up this channel this channel to start recording data</p>
            </div>
          )}
        {channel.location && weatherData.length > 0 && (
          <div>
            <WeatherChart
              period={period}
              onSetPeriod={this.setPeriod}
              unit={units}
              onSetUnit={this.handleSetUnits}
              timezone={channel.location.timezone}
              weather={weatherData}
              onClick={this.handleChartClick}
              chartMetric={chartMetric}
              onSetChartMetric={this.setChartMetric}
            />
            {weather &&
              weather.forecast &&
              weather.forecast.data &&
              weather.forecast.data.length && (
                <Forecast
                  data={weather.forecast.data}
                  metric={metric}
                  timezone={channel.location.timezone}
                />
              )}
            {selectedDatapoint && (
              <WeatherTable
                channel={channel}
                metric={metric}
                data={selectedDatapoint}
                timezone={channel.location.timezone}
              />
            )}
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            flexWrap: "wrap",
            paddingBottom: "12px",
          }}
        >
          {hasBeenActivated && (
            <div style={{ width: "100%" }}>
              <h3>Fund Status</h3>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "12px",
                }}
              >
                <ConditionsFundStatus channel={channel} audbsv={AUD_BSV} />
                {!hideForecasts &&
                  (forecastActivated ? (
                    <ForecastFundStatus channel={channel} audbsv={AUD_BSV} />
                  ) : (
                    <ForecastActivator channel={channel} />
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state, props) => ({
      channel: getThisChannel(state, props),
      weather: state.weather,
      settings: state.settings,
      loggedIn: isLoggedIn(state, props),
    }),
    {
      fetchForecastData,
      fetchWeatherData,
      fetchChannel,
    }
  )(Channel)
);
